import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-primary-action-button',
  imports: [],
  templateUrl: './primary-action-button.component.html',
  styleUrl: './primary-action-button.component.scss'
})
export class PrimaryActionButtonComponent {
  @Output() clickEmitter = new EventEmitter();
  @Input() buttonText!: string;
  @Input() color = '#000000';
  @Input() disabled = false;

  emitClick() {
    this.clickEmitter.emit();
  }
}
